import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserTermsConditionsService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/users-api' : environment.usersApiUrl;
    super(http, apiBaseUrl);
  }

  saveUserTermsConditionsAcceptance(): Observable<any> {
    return this.post<any>('user-terms-acceptance', null);
  }
}
